<template>
	<div class="content scroll-container">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
		<div class="about-banner wow animate__animated animate__fadeInUp animate__delay-0.3s">
			<img src="../../static/images/about/banner.png" v-show="currlangs == 0" >
			<img src="../../static/images/about/eng/1.png" v-show="currlangs == 1" >
			<img src="../../static/images/about/eng/3.png" v-show="currlangs == 2" >
		</div>
		<div class="about-content pa-content">
			<div class="container">
				<!-- 公司介绍 -->
				<div class="company-text cont-h1 wow animate__animated animate__fadeInUp animate__delay-0.3s">
					<h1>{{ langs.about1 }}</h1>
					<div class="text">{{ langs.about2 }}</div>
					<div class="text wow animate__animated animate__fadeInUp animate__delay-0.3s">{{ langs.about3 }}</div>
				</div>
				<!-- / 公司介绍 -->
			</div>
		</div>
		<!-- 核心价值 -->
		<div class="core-content pa-content">
			<div class="container">
				<div class="core-price cont-h1 wow animate__animated animate__fadeInUp animate__delay-0.3s">
					<h1>{{ langs.about4 }}</h1>
					<el-row>
						<el-col :xs="24" :md="8" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="core-img">
								<img src="../../static/images/about/3.png" alt=""></img>
							</div>
							<div class="core-txt">
								<h3>{{ langs.about5 }}</h3>
								<div class="">{{ langs.about6 }}</div>
								<div>{{ langs.about7 }}</div>
							</div>
						</el-col>
						<el-col :xs="24" :md="8" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="core-img">
								<img src="../../static/images/about/4.png" alt="" ></img>
							</div>
							<div class="core-txt">
								<h3>{{ langs.about5 }}</h3>
								<div class="">{{ langs.about8 }}</div>
								<div>{{ langs.about9 }}</div>
							</div>
						</el-col>
						<el-col :xs="24" :md="8" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="core-img">
								<img src="../../static/images/about/5.png" alt="" ></img>
							</div>
							<div class="core-txt">
								<h3>{{ langs.about10 }}</h3>
								<div class="">{{ langs.about11 }}</div>
								<div>{{ langs.about12 }}</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="core-expre cont-h1">
					<h2>{{ langs.about13 }}</h2>
					<el-row>
						<el-col :xs="24" :md="12" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="more-box">
								<div class="more-box-list">
									<h3>
										<img src="../../static/images/about/expre1.png" >
										{{ langs.about14 }}
									</h3>
									<div>{{ langs.about15 }}</div>
									<div>{{ langs.about16 }}</div>
								</div>
								<div class="more-box-list">
									<h3>
										<img src="../../static/images/about/expre2.png" >
										{{ langs.about17 }}
									</h3>
									<div>{{ langs.about18 }}</div>
									<div>{{ langs.about19 }}</div>
								</div>
								<div class="more-box-list">
									<h3>
										<img src="../../static/images/about/expre3.png" >
										{{ langs.about20 }}
									</h3>
									<div>{{ langs.about21 }}</div>
									<div>{{ langs.about22 }}</div>
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :md="12" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="more-img">
								<img src="../../static/images/about/6.png" v-show="currlangs == 0" >
								<img src="../../static/images/about/eng/2.png" v-show="currlangs == 1" >
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- 核心功能 -->
				<div class="core-system">
					<h1 class="wow animate__animated animate__fadeInUp animate__delay-0.3s">{{ langs.about23 }}</h1>
					<el-row>
						<el-col :xs="24" :md="8" class="system-left">
							<div class="system-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
								<img src="../../static/images/about/7-1.png" alt="" ></img>
								<div>{{ langs.about24 }}</div>
								<div>{{ langs.about25 }}</div>
								<div>{{ langs.about26 }}</div>
							</div>
							<div class="system-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
								<img src="../../static/images/about/7-2.png" alt="" ></img>
								<div>{{ langs.about27 }}</div>
								<div>{{ langs.about28 }}</div>
							</div>
							<div class="system-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
								<img src="../../static/images/about/7-3.png" alt="" ></img>
								<div>{{ langs.about29 }}</div>
								<div>{{ langs.about30 }}</div>
							</div>
						</el-col>
						<el-col :xs="24" :md="8">
							<div class="system-center wow animate__animated animate__fadeInUp animate__delay-0.3s">
								<img src="../../static/images/about/7.png" alt="" ></img>
							</div>
						</el-col>
						<el-col :xs="24" :md="8">
							<div class="system-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
								<img src="../../static/images/about/7-4.png" alt="" ></img>
								<div>{{ langs.about31 }}</div>
								<div>{{ langs.about32 }}</div>
							</div>
							<div class="system-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
								<img src="../../static/images/about/7-5.png" alt="" ></img>
								<div>{{ langs.about33 }}</div>
								<div>{{ langs.about34 }}</div>
								<div>{{ langs.about35 }}</div>
							</div>
							<div class="system-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
								<img src="../../static/images/about/7-6.png" alt="" ></img>
								<div>{{ langs.about36 }}</div>
								<div>{{ langs.about37 }}</div>
								<div>{{ langs.about38 }}</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- / 核心功能 -->
				<!-- 企业荣誉 -->
				<div class="core-honor">
					<h1 class="wow animate__animated animate__fadeInUp animate__delay-0.3s">{{ langs.about39 }}</h1>
					<el-row>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_1.jpg" ></img>
							</div>
						</el-col>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_2.jpg" ></img>
							</div>
						</el-col>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_3.jpg" ></img>
							</div>
						</el-col>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_4.jpg" ></img>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_5.jpg" ></img>
							</div>
						</el-col>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_6.jpg" ></img>
							</div>
						</el-col>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_7.jpg" ></img>
							</div>
						</el-col>
						<el-col :xs="24" :md="6" class="wow animate__animated animate__fadeInUp animate__delay-0.3s">
							<div class="honor-img">
								<img src="../../static/images/about/honor_8.jpg" ></img>
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- / 企业荣誉 -->
			</div>
		</div>
		<!-- / 核心价值 -->
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		data() {
			return {
				showLoading: true,

				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh,
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated）
					offset: 0,//到元素距离触发动画（当默认为0）
					mobile: true, //在移动设备上触发动画（默认为true）
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init()
			})
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.about-content{
		background: url(../../static/images/about/1.png);
		background-size: cover;
	}
	.company-text{
		margin: 30px 0px 50px;
	}
	.cont-h1 h1, .cont-h1 h2{
		text-align: center;
		padding: 30px 0px 20px;
	}
	.company-text .text{
		font-size: 18px;
		line-height: 28px;
	}
	/* 核心价值 */
	.core-price{
		margin-bottom: 20px;
	}
	.core-content{
		text-align: center;
	}
	.core-img{
		width: 150px;
		height: 150px;
		margin: 0px auto;
		padding: 20px 10px;
	}
	.core-txt h3{
		margin: 0px 0px 15px;
	}
	.core-content .more-box{
		text-align: left;
	}
	.core-expre{
		margin-bottom: 50px;
	}
	.more-box{
		padding: 20px;
	}
	.more-box-list{
		padding: 12px 0px;
		border-bottom: 1px solid #eee;
	}
	.more-box-list h3{
		height: 30px;
		line-height: 30px;
		margin: 10px 0px;
	}
	.more-box-list h3 img{
		width: 30px;
		height: 30px;
		float: left;
		margin-right: 20px;
	}
	.more-box-list div{
		margin-left: 50px;
	}
	.more-img{
		width: 500px;
		max-width: 100%;
		overflow: hidden;
	}
	/* 核心功能 */
	.core-system .el-row{
		margin: 50px 0px 30px;
	}
	.system-center{
		display: inline-block;
		text-align: center;
		width: 300px;
	}
	.system-list{
		height: 70px;
		margin-bottom: 60px;
	}
	.system-list img{
		width: 70px;
		float: left;
		margin-right: 10px;
		margin-top: -5px;
	}
	.system-list div{
		text-align: left;
		line-height: 22px;
	}
	.system-left .system-list img{
		float: right;
		margin-right: 0px;
		margin-left: 10px;
	}
	.system-left .system-list div{
		text-align: right;
		line-height: 22px;
	}
	/* 公司荣耀 */
	.core-honor{
		margin: 0px 0px 80px;
	}
	.honor-img{
		width: 200px;
		padding: 20px;
		text-align: center;
		margin: 0px auto;
	}
	@media screen and (max-width: 768px) {
		.company-text h1{
			padding: 10px 0px;
		}
		.system-left .system-list img{
			float: left;
			margin-right: 10px;
		}
		.system-list{
			margin-bottom: 30px;
		}
		.system-left .system-list div{
			text-align: left;
			line-height: 22px;
		}
		.system-center{
			margin-bottom: 30px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/aboutus.vue